import { useMemo, useState } from "react";
import {
  IconBolt,
  IconHome2,
  IconMessageCircleQuestion,
} from "@tabler/icons-react";
import CmsLayout from "@layouts/CmsLayout";
import HomeContentTabs from "@components/home_content/HomeContentTabs";
import HomeSection from "@components/home_content/sections/HomeSection";
import CarbonFootPrintSection from "@components/home_content/sections/CarbonFootPrintSection";
import FaqsSection from "@components/home_content/sections/FaqsSection";
import "@assets/css/tour/add.css";
import "@assets/css/home_content/panel.css";

const HOME_CONTENT_TABS = [
  { id: "home", label: "Home", Icon: IconHome2 },
  { id: "carbon-foot-print", label: "Carbon Foot Print", Icon: IconBolt },
  {
    id: "faqs",
    label: "FAQs",
    Icon: IconMessageCircleQuestion,
  },
];

const HOME_CONTENT_VIEW_BY_TAB = {
  home: HomeSection,
  "carbon-foot-print": CarbonFootPrintSection,
  faqs: FaqsSection,
};

function HomeContentPage() {
  const [activeTab, setActiveTab] = useState(HOME_CONTENT_TABS[0].id);
  const ActiveSection = useMemo(
    () => HOME_CONTENT_VIEW_BY_TAB[activeTab] || HomeSection,
    [activeTab],
  );

  return (
    <CmsLayout activeModule="home-content" title="Home Content">
      <section className="panel table-panel home-content-panel">
        <div className="home-content-panel-inner">
          <div className="index-table-bar home-content-panel-head">
            <div>
              <h2>Home Content</h2>
            </div>
          </div>

          <HomeContentTabs
            tabs={HOME_CONTENT_TABS}
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />

          <div className="home-content-panel-body">
            <ActiveSection />
          </div>
        </div>
      </section>
    </CmsLayout>
  );
}

export default HomeContentPage;
